import { styled } from 'baseui'

export enum GridSize {
    Grid3,
    Grid6,
}

const Grid = styled('div', (props: { $gridSize: GridSize }) => props.$gridSize === GridSize.Grid6 ? ({
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    gap: '12px',
    width: '100%',
}) : ({ display: 'flex', flexWrap: 'wrap', gap: '8px', width: '292px' }))

interface InspectorGridProps {
    gridSize: GridSize; // Replace `GridSize` with your actual type definition
    children?: React.ReactNode; // Allow optional children
}

function InspectorGrid({ gridSize, children }: InspectorGridProps) {
    return (
        <Grid $gridSize={gridSize}>
            {children}
        </Grid>
    );
}

export default InspectorGrid
